import { AGGREGATE_NAMES, USER_RESOLVERS } from 'cpool-constants';
import { schemaUserResolver_GetUserNameById } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useGetUserNameById = (userId: string | undefined) => {
    const { data } = useAggregateQuery({
        acl: { userId },
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.getUserNameById,
        schema: schemaUserResolver_GetUserNameById,
        searchParams: { userId },
        tanstack: {
            enabled: Boolean(userId),
        },
    });

    return data;
};
